import React, { useState } from "react";
import { toast } from "react-toastify";
import { apiPut } from "../../API/Api_Url";

function SupplierAddDispatchDetailsModel({ isOpen, onClose, Materialrequest, GetAllAssignedMaterialRequest }) {
    const [formData, setFormData] = useState({
        TruckNumber: "",
        DriverContact: "",
        ETA: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const [isLoading, setisLoading] = useState(false);

    const SupplierAddDispatchDetails = async () => {
        if (!formData.TruckNumber || !formData.DriverContact || !formData.ETA) {
            toast.error("Please fill all fields");
            return;
        }
        try {
            setisLoading(true);
            const response = await apiPut(`api/material-supplier/SupplierAddDispatchDetails/${Materialrequest?._id}`, formData);

            if (response?.data) {
                toast.success(response?.message);
                onClose();
                GetAllAssignedMaterialRequest();
            } else {
                toast.error(response?.message || "Failed to update quotation");
            }
        } catch (error) {
            console.error("Error updating quotation:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setisLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6">
                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Add Dispatch Details
                </h2>
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Truck Number
                    </label>
                    <input
                        type="text"
                        name="TruckNumber"
                        value={formData.TruckNumber}
                        onChange={handleChange}
                        placeholder="MH12AB1234"
                        className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Driver Contact
                    </label>
                    <input
                        type="number"
                        name="DriverContact"
                        value={formData.DriverContact}
                        onChange={handleChange}
                        placeholder="+91-9876543210"
                        className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Estimated Time of Arrival (ETA)
                    </label>
                    <input
                        type="datetime-local"
                        name="ETA"
                        value={formData.ETA}
                        min={new Date().toISOString().slice(0, 16)} 
                        onChange={handleChange}
                        className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={SupplierAddDispatchDetails}
                        className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                        {isLoading ? "Please Wait" : 'Add Dispatch Details'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SupplierAddDispatchDetailsModel;
